import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
function isMobile() {
  // Check user agent first - include Firefox Mobile pattern for Android Firefox
  const userAgentCheck = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|(Mobile.*Firefox)|(Mobile.*Gecko)/i.test(navigator.userAgent);
  // Check for touch capability
  const touchCheck = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  // Check screen size
  const screenCheck = window.innerWidth <= 768;
  return userAgentCheck || touchCheck && screenCheck;
}
function shouldUseNativeSharing(isMobileChecker: () => boolean) {
  const isMobile = isMobileChecker();
  const isShareAvailable = 'share' in navigator;
  const isCanShareAvailable = 'canShare' in navigator;
  const canShare = isCanShareAvailable && navigator?.canShare({
    files: [new File([''], 'instagram.png')]
  });
  return isMobile && isShareAvailable && canShare;
}
function useNativeShareAvailable() {
  const $ = _c(2);
  const [nativeShareAvailable, setNativeShareAvailable] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const timeout = setTimeout(() => {
        const canUseNativeShare = shouldUseNativeSharing(isMobile);
        setNativeShareAvailable(canUseNativeShare);
      }, 0);
      return () => clearTimeout(timeout);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return nativeShareAvailable;
}
export default useNativeShareAvailable;